<div class="carousel-swiper-container">
  <div class="carousel-prev carousel-button" (click)="scrollPrev()" *ngIf="items.length > 1 && hasOverflow" [class.swiper-button-disabled]="isAtStart">
    <mat-icon>chevron_left</mat-icon>
  </div>

  <div #scrollContainer class="scroll-container" (scroll)="onScroll()">
    <ng-container *ngFor="let item of items; let i = index">
      <ng-container *ngTemplateOutlet="slideTemplate; context: { $implicit: item, index: i }"></ng-container>
    </ng-container>
  </div>

  <div class="carousel-next carousel-button" (click)="scrollNext()" *ngIf="items.length > 1 && hasOverflow" [class.swiper-button-disabled]="isAtEnd">
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
